import styled from "styled-components";
import { Button as AntButton } from 'antd';

export const RootContainer = styled.div`
padding: 24px 16px 16px 16px;
height: calc(100vh - 176px);
overflow-y: auto;
`;

export const Loader = styled.div`
height: calc(100vh - 136px);
display: flex;
align-items: center;
justify-content: center;
`;

export const EmptyBox = styled.div`
height: calc(100vh - 136px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 24px;
        color: #808080;
    }
`;

export const EmptyText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;

export const Item = styled.div`
padding: 30px 13px 13px 13px;
margin-bottom: 30px;
border-radius: 20px;
background: #EFEFEF;
position: relative;

display: flex;
flex-direction: column;
gap: 12px;

.ant-space .ant-space-item {
    flex: 1;
}
`;

export const Divider = styled.div`
width: 100%;
height: 1px;
background: #E5E0F5;
`;

export const DateBox = styled.div`
position: absolute;
top: -14px;
left: 50%;
transform: translate(-50%, 0%);

min-width: 38%;
text-align: center;
padding: 7px;
border-radius: 8px;
background: #C21C05;

font-size: 14px;
font-weight: 700;
color: #fff;
`;

export const Text = styled.div`
font-size: 14px;
font-weight: 400;
color: #101415;
`;

export const LightText = styled.div`
font-size: 14px;
font-weight: 700;
color: #C21C05;
text-align: right;
`;

export const StatusBox = styled.div`
padding: 5px 10px;
border: 1px solid #D93B0C;
border-radius: 5px;
display: inline;

font-size: 12px;
font-weight: 400;
color: #000;
`;

export const Button = styled(AntButton)`
	box-sizing: border-box !important ;
	position: fixed;
	bottom: 12px;
    width: calc(100% - 32px) !important;
    max-width: 448px;
    margin-left: 16px;
	height: 52px !important;
	border-radius: 27px !important;
	background-color: #C21C05 !important;

	color: #F7F7F7 !important;
	font-size: 14px !important;
	font-style: normal;
	font-weight: 700 !important;
	line-height: 1.5;

	:hover {
		background-color: #C21C05 !important;
		color: #F7F7F7 !important;
	}
`;

export const TopBox = styled.div`
	padding: 13px 16px;
	margin-bottom: 39px;
	border-radius: 8px;
	background: linear-gradient(180deg, #B51F07 0%, #6D1304 100%);

	font-size: 14px;
	font-weight: 700;
	line-height: 1.5;
	color: #F9F9F9;
	text-align: center;
`;